import React, { useState } from 'react';
import { setCallback } from '../../services/crmService';
import { ui } from './crmUi';

// Asked after a "Call back" call result: pick a date and time.
const at = (daysAhead, h, m = 0) => { const d = new Date(); d.setDate(d.getDate() + daysAhead); d.setHours(h, m, 0, 0); return d; };
const laterToday = () => { const d = new Date(); d.setMinutes(0, 0, 0); d.setHours(d.getHours() + 3); return d; };
const nextMonday = () => { const d = at(1, 10); while (d.getDay() !== 1) d.setDate(d.getDate() + 1); return d; };
const pad = (n) => String(n).padStart(2, '0');
const localInput = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

export default function CallbackModal({ contact, uid, isAdmin, onDone }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [custom, setCustom] = useState('');
  if (!contact) return null;
  const late = laterToday();
  const quick = [
    ...(late.getDate() === new Date().getDate() && late.getHours() <= 20 ? [['Later today', late]] : []),
    ['Tomorrow 10am', at(1, 10)], ['Tomorrow 2pm', at(1, 14)], ['In 2 days 10am', at(2, 10)], ['Next Monday 10am', nextMonday()], ['In 1 week', at(7, 10)],
  ];
  const pick = async (d) => {
    setBusy(true);
    try { await setCallback(contact, d, uid, isAdmin); onDone(); } catch (e) { setErr(e.message || 'Could not save.'); setBusy(false); }
  };
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(20, 24, 33, 0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 1100 }}>
      <div role="dialog" aria-modal="true" style={{ background: '#FFFFFF', borderRadius: 12, padding: 24, width: '100%', maxWidth: 440, boxShadow: '0 12px 40px rgba(0,0,0,0.25)', boxSizing: 'border-box' }}>
        <h3 style={ui.sectionTitle}>When should you call back?</h3>
        <p style={ui.sub}>{[contact.firstName, contact.lastName].filter(Boolean).join(' ') || contact.name}. A "Call back" task is added to your tasks.</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: 8 }}>
          {quick.map(([label, d]) => <button key={label} disabled={busy} style={ui.btn} title={d.toLocaleString()} onClick={() => pick(d)}>{label}</button>)}
        </div>
        <label style={ui.label}>Or pick a date and time</label>
        <div style={ui.row}>
          <input type="datetime-local" style={{ ...ui.input, flex: 1, width: 'auto' }} min={localInput(new Date())} value={custom} onChange={(e) => setCustom(e.target.value)} />
          <button style={ui.btn} disabled={busy || !custom || new Date(custom) <= new Date()} onClick={() => pick(new Date(custom))}>Set</button>
        </div>
        {err && <div style={{ color: '#D64545', fontSize: 13, marginTop: 8 }}>{err}</div>}
        <button style={{ ...ui.ghost, marginTop: 12 }} disabled={busy} onClick={onDone}>Skip</button>
      </div>
    </div>
  );
}
